
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import gsap from 'gsap'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false)
        const isLoaded = ref<boolean>(false)

        const goPuzzle = () => {
            $store.commit('SET_PAGE', 'Puzzle')
        }

        const imgLoad = (node) => {
            const target = node as HTMLImageElement
            const map = target.parentNode as HTMLDivElement
            const t = target.getBoundingClientRect().height - map.getBoundingClientRect().height
            gsap.fromTo(target, {
                transform: `translate3d(0, 0, 0)`,
            }, {
                transform: `translate3d(0, -${t}px, 0)`,
                ease: 'none',
                duration: Math.ceil(t / 10),
                repeat: -1,
                delay: 1.5,
                yoyo: true
            })
        }

        const allImgLoad = () => {
            const imgs = document.querySelectorAll('.page-home img')
            let loadCount = 0
            for (let i = 0; i < imgs.length; i++) {
                imgs[i].addEventListener('load', () => {
                    loadCount++
                    if (loadCount === imgs.length) {
                        setTimeout(() => {
                            isLoaded.value = true
                            COVER.pageLoaded()
                            imgLoad(document.querySelector('.map-img'))
                        }, 500)
                    }
                })
            }
        }

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            nextTick(() => {
                isApp.value && COVER.getUser((res: any) => {
                    $store.commit('SET_USERINFO', res)
                })
                COVER.track('load', $store.state.activityData.title)
                COVER.onshare($store.state.shareData)
                allImgLoad()
            })
        })    

        return {
            isLoaded,
            goPuzzle
        }
    }
})
